var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-table-list systemManage-user"},[(_vm.userType ===203 || _vm.userType ===204)?[_c('manageUser')]:[_c('manageCustom')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }